import API, { baseURL } from "../../../../../global/api";
import { isEmpty, sumBy } from "lodash";
import { handleNoDataVisible, PDFHeader } from "../../../../../global/globalFunctions";
import moment from "moment";
import jsPDF from 'jspdf';
import 'jspdf-autotable';


export const requestAddReceiving = () => {
    return {
        type: "REQUEST_ADD_RECEIVING",
    };
};
export const successAddReceiving = (data) => {
    return {
        type: "SUCCESS_ADD_RECEIVING",
        payload: data,
    };
};
export const errorAddReceiving = () => {
    return {
        type: "ERROR_ADD_RECEIVING",
    };
};
export const AddReceivingApi = (data, handleVisible, handleDangerVisible) => {
    return (dispatch) => {
        dispatch(requestAddReceiving());
        API.post(`/receiving/add-receiving`, data).then((res) => {
            dispatch(successAddReceiving(data));
            handleVisible(res.data.message);
        }).catch((error) => {
            dispatch(errorAddReceiving());
            handleDangerVisible(error.response.data.message);
        })
    }
};


export const requestGetReceiving = () => {
    return {
        type: "REQUEST_GET_RECEIVING",
    };
};
export const successGetReceiving = (data) => {
    return {
        type: "SUCCESS_GET_RECEIVING",
        payload: data,
    };
};
export const errorGetReceiving = () => {
    return {
        type: "ERROR_GET_RECEIVING",
    };
};
export const GetReceivingApi = () => {
    return (dispatch) => {
        dispatch(requestGetReceiving());
        API.get(`${baseURL}/receiving/get-receiving?page=0&limit=1000`).then((res) => {
            let getData = res.data;
            dispatch(successGetReceiving(getData));
        }).catch((error) => {
            dispatch(errorGetReceiving());
        })
    }
};


export const requestSearchRecivingByDate = () => {
    return {
        type: "REQUEST_SEARCH_Reciving_BY_DATE",
    };
};
export const successSearchRecivingByDate = (data) => {
    return {
        type: "SUCCESS_SEARCH_Reciving_BY_DATE",
        payload: data,
    };
};
export const errorSearchRecivingByDate = () => {
    return {
        type: "ERROR_SEARCH_Reciving_BY_DATE",
    };
};
export const SearchReceivingWithDateApi = (data, startDate, endDate) => {
    return (dispatch) => {
        dispatch(requestSearchRecivingByDate());
        API.post(`${baseURL}/receiving/receiving_with_dates`, data).then((res) => {
            let getData = res.data;
            dispatch(successSearchRecivingByDate(getData));
        }).catch((error) => {
            dispatch(errorSearchRecivingByDate());
        })
    }
};
export const GetReceivingByDatePDFApi = (data, startDate, endDate) => {
    return (dispatch) => {
        dispatch(requestSearchRecivingByDate());
        API.post(`${baseURL}/receiving/receiving_with_dates`, data).then((res) => {
            let result = res.data.data;
            console.log(result, "result");
            if (isEmpty(result)) {
                handleNoDataVisible();
            } else {
                const unit = "pt";
                const size = "A4";
                const orientation = "l";
                const doc = new jsPDF(orientation, unit, size);
                PDFHeader(doc, "Receiving Report");

                doc.setFontSize(12);
                doc.setFont("Times New Roman", "normal")
                doc.text(`Start Date: ${moment(startDate).format('DD-MM-YYYY')}  -  End Date: ${moment(endDate).format('DD-MM-YYYY')}`, 50, 125)

                const headers = [[
                    "S.No",
                    "Company Name",
                    "Vendor Name",
                    "Date",
                    "Total Bill",
                    "Leak Discount",
                    "Tax",
                    "Freight",
                    "Grand Total",
                    "Receivied By",
                    "Description",
                ]];
                const prodactData = isEmpty(result) ? [] : result.map((elt, i) => [
                    elt.sequenceNumber,
                    elt.restaurantId?.restaurantName,
                    elt.vendorDetails?.vendorName,
                    elt.receivingDate,
                    elt.totalBill,
                    elt.leakDiscount,
                    elt.tax,
                    elt.freight,
                    elt.netPayable,
                    elt.receivedBy,
                    elt.recivingDescription,
                ]);
                if (!isEmpty(prodactData)) {
                    prodactData.push([
                        "",
                        { content: "TOTAL", colSpan: 1, styles: { halign: "left", fontStyle: "bold" } },
                        "",
                        "",
                        { content: parseFloat(sumBy(prodactData, '4').toFixed()), styles: { halign: "left", fontStyle: "bold" } },
                        { content: parseFloat(sumBy(prodactData, '5').toFixed()), styles: { halign: "left", fontStyle: "bold" } },
                        { content: parseFloat(sumBy(prodactData, '6').toFixed()), styles: { halign: "left", fontStyle: "bold" } },
                        { content: parseFloat(sumBy(prodactData, '7').toFixed()), styles: { halign: "left", fontStyle: "bold" } },
                        { content: parseFloat(sumBy(prodactData, '8').toFixed()), styles: { halign: "left", fontStyle: "bold" } },

                    ])
                }
                let ProductContent = {
                    startY: 135,
                    startX: 50,
                    head: headers,
                    styles: { fontSize: 9 },
                    body: prodactData,
                    theme: "grid",
                    headStyles: { fillColor: "#2980ba" },
                };
                doc.autoTable(ProductContent);

                doc.setProperties({ title: `Receiving Report` });
                var blob = doc.output("blob");
                window.open(URL.createObjectURL(blob));
            }
            dispatch(successSearchRecivingByDate(result));
        }).catch((error) => {
            dispatch(errorSearchRecivingByDate());
        })
    }
};


export const individualPDF = (data) => {
    return (dispatch) => {
        const unit = "pt";
        const size = "A4";
        const orientation = "p";
        const doc = new jsPDF(orientation, unit, size);
        PDFHeader(doc, "Receiving Report");

        const headers = [[
            "S.No",
            "Item",
            "Purchase Price",
            "Quantity",
            "Total Price",
        ]];
        const prodactData = isEmpty(data?.receivingData) ? [] : data?.receivingData.map((elt, i) => [
            i + 1,
            elt.productName,
            elt.purchasePrice,
            elt.requiredProductQuantity,
            Number(elt.requiredProductQuantity || 0) * Number(elt.purchasePrice || 0),
        ]);
        if (!isEmpty(prodactData)) {
            prodactData.push([
                "",
                { content: "TOTAL", colSpan: 1, styles: { halign: "left", fontStyle: "bold" } },
                { content: parseFloat(sumBy(prodactData, '2').toFixed()), styles: { halign: "left", fontStyle: "bold" } },
                { content: parseFloat(sumBy(prodactData, '3').toFixed()), styles: { halign: "left", fontStyle: "bold" } },
                { content: parseFloat(sumBy(prodactData, '4').toFixed()), styles: { halign: "left", fontStyle: "bold" } },
            ])
        }
        let ProductContent = {
            startY: 235,
            startX: 50,
            head: headers,
            styles: { fontSize: 9 },
            body: prodactData,
            theme: "grid",
            headStyles: { fillColor: "#2980ba" },
        };
        doc.autoTable(ProductContent);

        doc.setFontSize(12);
        doc.setFont("Times New Roman", "normal")
        doc.text(`Receiving No: ${data.sequenceNumber}`, 50, 130, 0, 20);
        doc.text(`Vendor: ${data?.vendorDetails?.vendorName}`, 50, 145, 0, 20);
        doc.text(`Company: ${data?.restaurantId}`, 50, 160, 0, 20);
        doc.text(`Receiving Date: ${moment(data?.receivingDate).format('DD-MM-YYYY')}`, 50, 175, 0, 20);
        doc.text(`Description: ${data?.recivingDescription}`, 50, 190, 0, 20);
        doc.text(`Created By: ${data?.userDetails?.userName}`, 50, 205, 0, 20);
        doc.text(`Received By: ${data?.receivedBy}`, 50, 220, 0, 20);


        doc.setProperties({ title: `Receiving Report` });
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
    };
};


export const requestAddReceivingReturn = () => {
    return {
        type: "REQUEST_ADD_RECEIVING_RETURN",
    };
};
export const successAddReceivingReturn = (data) => {
    return {
        type: "SUCCESS_ADD_RECEIVING_RETURN",
        payload: data,
    };
};
export const errorAddReceivingReturn = () => {
    return {
        type: "ERROR_ADD_RECEIVING_RETURN",
    };
};
export const AddReceivingReturnApi = (data, handleVisible, handleDangerVisible) => {
    return (dispatch) => {
        dispatch(requestAddReceivingReturn());
        API.post(`/receiving/return-receiving`, data)
            .then((res) => {
                dispatch(successAddReceivingReturn(data));
                handleVisible(res.data.message);
            }).catch((error) => {
                dispatch(errorAddReceivingReturn());
                handleDangerVisible(error.response.data.message);
            });
    };
};


export const DeleteRequestReceiving = () => {
    return {
        type: "DELETE_REQUEST_RECEIVING",
    };
};
export const DeleteSuccessReceiving = (id) => {
    return {
        type: "DELETE_SUCCESS_RECEIVING",
        id: id,
    };
};
export const DeleteErrorReceiving = () => {
    return {
        type: "DELETE_ERROR_RECEIVING",
    };
};
export const DeleteReceivingApi = (id) => {
    return (dispatch) => {
        dispatch(DeleteRequestReceiving());
        API.delete(`/receiving/delete-receiving/${id}`)
            .then((res) => {
                dispatch(DeleteSuccessReceiving(id));
            }).catch((error) => {
                dispatch(DeleteErrorReceiving());
            });
    };
};